import { memo, useState } from 'react';
import { LoanService } from '../../services';
import { useError } from '../../contexts/ErrorContext';
import { useNotification } from '../../contexts/NotificationContext';
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import ConfirmationModal from '../../components/ConfirmationModal';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import LoadingModal from '../../components/LoadingModal';
import { LOAN_HOLD_STATUS } from '../../utils/constants';

const BulkPendingReleaseButton = ({selectedRowIndices, holds, currentDate}) => {
  const [showPendingReleaseConfirmation, setShowPendingReleaseConfirmation] = useState(false);
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const { showError } = useError();
  const { createErrorNotification } = useNotification();

  const togglePendingReleaseConfirmation = () => setShowPendingReleaseConfirmation(!showPendingReleaseConfirmation);
  const openLoadingModal = () => setShowLoadingModal(true);
  const closeLoadingModal = () => setShowLoadingModal(false);

  // Bulk pending release is exclusively available for loans hold for funding.
  const selectedHolds = selectedRowIndices.map(rowId => holds[rowId]);
  const allHoldForFunding = selectedHolds.length > 0 &&
    selectedHolds.every(hold => hold.holdStatus === LOAN_HOLD_STATUS.HOLD_FOR_FUNDING);

  if (!allHoldForFunding) {
    return null;
  }

  const handlePendingReleaseClick = () => {
    if (!currentDate) {
      createErrorNotification('You can only modify holds for current date');
      return;
    }
    togglePendingReleaseConfirmation();
    openLoadingModal();
    LoanService.bulkMarkPendingRelease(selectedHolds.map(hold => hold.loanNumber)).then(response => {
      window.location.reload();
    }).catch(showError)
      .finally(() => {
        closeLoadingModal();
    });
  }

  return (
    <>
      <Tooltip title={currentDate ? 'Bulk Pending Release Selected Loans' : 'You can only modify holds for current date'}>
        <IconButton onClick={togglePendingReleaseConfirmation} >
          <EventAvailableIcon />
        </IconButton>
      </Tooltip>
      <ConfirmationModal title="Confirm" message="Are you sure you want to mark these loans as pending release? They will be released tomorrow." onConfirm={handlePendingReleaseClick} onCancel={togglePendingReleaseConfirmation} showConfirmationBox={showPendingReleaseConfirmation}/>
      <LoadingModal open={showLoadingModal} />
    </>
  );
}

export default memo(BulkPendingReleaseButton);
